import { PERSONAS } from "@macroscope/shared";
import type { Persona } from "@macroscope/shared";

interface Props {
  value: Persona;
  onChange: (p: Persona) => void;
}

export function PersonaSelector({ value, onChange }: Props) {
  return (
    <div className="flex flex-wrap gap-2">
      {PERSONAS.map((p) => (
        <button
          key={p.id}
          onClick={() => onChange(p.id as Persona)}
          className={`rounded-lg border px-3 py-1.5 text-xs font-medium transition-colors ${
            value === p.id
              ? "border-macro-accent bg-macro-accent/10 text-macro-accent"
              : "border-surface-2 bg-surface-1 text-slate-400 hover:bg-surface-2"
          }`}
        >
          {p.label}
        </button>
      ))}
    </div>
  );
}
